export default function providerName() {
    return (name) => {
        name = name.replace(/-/g, '_');
        name = name.replace('commercial', 'evp');
        name = name.replace('official_by_partner', 'official');
        return name;
    }
}
